import { slider } from "./components/slider";


$(function () {

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  var windowWidth = window.innerWidth;
  var headerHight = 0;
  if(windowWidth > 767) {
    headerHight = 120;
  } else {
    headerHight = 50;
  }
  $('a[href^="#"]').on('click', function() {
    var speed = 1000;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHight;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });

  if($('.p-header--top').length > 0) {
    const target = $('.p-header');
    $(document).on('scroll', function() {

      if($(document).scrollTop() > window.innerHeight) {
        if(target.hasClass('p-header--top')) {
          target.removeClass('p-header--top');
        }
      } else {
        if(!target.hasClass('p-header--top')) {
          target.addClass('p-header--top');
        }
      }
    });
  }

  if($('.p-interview__item__button').length > 0) {
    const target = $('.p-interview__item__button > a');
    target.on('click', function(e) {

      const modalNo = e.target.dataset.to_modal;
      if($(`#modal-${modalNo}`).length > 0) {
        $(`#modal-${modalNo}`).show();
        $('.p-modal__back').show();
        $('body').css('overflow-y', 'hidden');
      }
      e.preventDefault();
    });
  }

  if($('.p-modal__close-button').length > 0) {
    const target = $('.p-modal__close-button');
    target.on('click', function(e) {
      const modalNo = e.target.dataset.modal;
      if($(`#modal-${modalNo}`).length > 0) {
        $(`#modal-${modalNo}`).hide();
        $('.p-modal__back').hide();
        $('body').css('overflow-y','auto');
      }
    });
  }

  if($('.p-modal__button-container').length > 0) {
    const target = $('.p-modal__button-container > button');
    target.on('click', function(e) {
      $('.p-modal').each(function(i, v) {
        if($(v).is(':visible')) {
          $(v).hide();
          $('.p-modal__back').hide();
          $('body').css('overflow-y','auto');
        }
      });
    });
  }

  if($('.p-modal__back').length > 0) {
    $('.p-modal__back').on('click', function(e) {
      $('.p-modal').each(function(i, v) {
        if($(v).is(':visible')) {
          $(v).hide();
          $('.p-modal__back').hide();
          $('body').css('overflow-y','auto');
        }
      });
    });
  }

  $('.p-header__burger').on('click', function(e) {
    toggleMenu();
  });

  $('.p-header__navi__button').on('click', function(e) {
    toggleMenu();
  });

  function toggleMenu() {
    const target = $('.p-header__navi');
    if(target.hasClass('p-header__navi--opened')) {
      // target.hide();
      // console.log('hhh');
      target.removeClass('p-header__navi--opened');
    } else {
      // target.show();
      // console.log('hhhasdasd');
      target.addClass('p-header__navi--opened');
    }
    $('.p-header__burger').toggleClass('c-burger--active');

  }

  $('.mw_wp_form form').addClass('h-adr');
  new YubinBango.MicroformatDom();

  // (() => {
  //   /*
  //   ページトップボタン用関数
  //   */
  //   //ボタンクラス定義
  //   const pageTopButtonEl = "#pageTop";
  //   //初期状態を定義
  //   const hide = true;
  //   pageTop(pageTopButtonEl, hide);
  // })();

});
